import React from "react";
import { Box } from "@mui/material";
import { SplitIntersectionIndicator } from "../../../utils/splitIntersectionUtils";

export interface SplitForegroundIndicatorProps {
  indicators?: SplitIntersectionIndicator[];
  paneIndex?: number;
  dataTestId?: string;
}

export const SplitForegroundIndicator: React.FC<SplitForegroundIndicatorProps> = ({
  indicators = [],
  paneIndex,
  dataTestId,
}) => {
  const activeIndicators = indicators.filter(
    (ind) =>
      (paneIndex === undefined || ind.paneIndex === paneIndex) &&
      ind.isVisible !== false
  );

  return (
    <Box
      data-testid={
        dataTestId ||
        (paneIndex !== undefined
          ? `split-foreground-indicator-pane-${paneIndex}`
          : "split-foreground-indicator-overlay")
      }
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: "none",
        zIndex: 10,
        overflow: "hidden",
      }}
    >
      {activeIndicators.map((indicator, idx) => {
        const isOutgoing = indicator.role === "outgoing";

        return (
          <Box
            key={`${indicator.pairId}-${indicator.role}-${idx}`}
            data-testid={
              isOutgoing
                ? "split-foreground-indicator-outgoing"
                : "split-foreground-indicator-incoming"
            }
            sx={{
              position: "absolute",
              top: indicator.viewportTop,
              left: 0,
              right: 0,
              height: Math.max(indicator.rowHeight, 26),
              bgcolor: "rgba(0, 0, 0, 0.05)",
              borderTop: "1px dashed #cbd5e1",
              borderBottom: "1px dashed #cbd5e1",
              borderLeft: isOutgoing ? "3px solid #94a3b8" : "none",
              borderRight: !isOutgoing ? "3px solid #94a3b8" : "none",
              boxSizing: "border-box",
              pointerEvents: "none",
            }}
          />
        );
      })}
    </Box>
  );
};
